import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'some',
})
export class SomePipe implements PipeTransform {
  transform(array: Array<any>, item: any): boolean {
    if (Array.isArray(array) && array.length > 0 && !!item) {
      return array.some(i => i === item);
    }
    return false;
  }
}
